// **********************************
// Copyright (c) 2013 Fluke Calibration. 
// All Rights Reserved
//
// Created 7/19/2013
// **********************************

// Priority Enum
var PRIORITY = {
    Critical: 'Critical',
    Medium: 'Medium',
    Low: 'Low'
};

var ErrorObj = function (ex) {
    ex = ex || {};
    this.Name = ex.name || 'Generic Error';
    this.Message = ex.message || '';
    this.Description = ex.description || '';
    this.Number = ex.number || '';
    this.LineNumber = ex.lineNumber || '';
    this.Stack = ex.stack || '';
    this.Url = ex.url || '';

};

// This method will log an error to the system. Pass
// an object to have it parse out the object and store that.
function Log(ex) {

    // Create a variable to store message.
    ex = ex || {};
    var msg = new ErrorObj(ex);

    // Send off the log request.
    $.ajax({
        url: '/Log/Assert',
        type: 'post',
        dataType: 'json',
        beforeSend: function (request) {
            request.setRequestHeader("Err-Name", escape(msg.Name));
            request.setRequestHeader("Err-Message", escape(msg.Message));
            request.setRequestHeader("Err-LineNumber", msg.LineNumber);
            request.setRequestHeader("Err-Url", msg.Url);
        },
        data: {
            Name: msg.Name,
            Message: escape(msg.Message),
            LineNumber: msg.LineNumber,
            Number: msg.Number,
            Stack: msg.Stack,
            Url: msg.Url
        }
    });
}

// OVERRIDE THE ONERROR METHOD
$(document).ready(function () {
    window.onerror = function (msg, url, line) {
        // Who logs the logger?
        // Adding a try/catch just for saftey.		
        try {
            Log({
                name: 'Javascript Error',
                message: msg,
                lineNumber: line,
                url: url
            });
        } catch (ex) { }
    };
});